// Kept for ErrorPage/Fallback, which are react-bootstrap based. The react-dates,
// typeahead and toastify stylesheets that used to be imported here went with the
// screens that used them.
import "bootstrap/dist/css/bootstrap.min.css";
import {Provider} from "react-redux";
import store from "./store";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import {setCurrentTeacher} from "./actions/authActions";
import React from "react";

import ErrorPage from "./components/error/ErrorPage";
import MigrationPage from "./components/migration/MigrationPage";

/*
 * Vikaaria has moved to a new application and this deployment is retired.
 *
 * The router and every route it served have been removed rather than hidden:
 * there is no login screen to submit, and a user arriving with a valid token
 * still in localStorage lands on the same migration page as everybody else.
 * The backend refuses the corresponding endpoints as well, so nothing here is
 * the only thing standing between a visitor and the old app.
 *
 * The token is still decoded into the store for one reason: MigrationPage reads
 * `siteLang` off it to pick the language.
 */

// Wrapped because this runs at module scope, outside the error boundary: a
// malformed token would otherwise throw before React mounts and leave the user
// on a blank page with nothing to click. Picking the wrong language is a far
// better failure than showing nothing, so a bad token just falls through to the
// country context default.
if (localStorage.jwtToken) {
    try {
        const token = localStorage.jwtToken;
        setAuthToken(token);
        const decoded = jwt_decode(token);
        store.dispatch(setCurrentTeacher(decoded));
    } catch (error) {
        console.error("Could not read the stored token:", error);
    }
}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        console.error(error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return <ErrorPage/>;
        }
        return (
            <Provider store={store}>
                <MigrationPage/>
            </Provider>
        );
    }
}

export default App;
